import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import './HomePage.css';

function HomePage() {
  const [myProjects, setMyProjects] = useState([]);
  const [sharedProjects, setSharedProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuth();

  useEffect(() => {
    const fetchProjects = async () => {
      if (!user) {
        setMyProjects([]);
        setSharedProjects([]);
        setIsLoading(false);
        return;
      }
      try {
        const projectsRef = collection(db, 'projects');
        const snapshot = await getDocs(projectsRef);
        const projectsData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          createdAt: new Date(doc.data().createdAt).toLocaleDateString(),
          lastModified: doc.data().lastModified 
            ? new Date(doc.data().lastModified).toLocaleDateString()
            : new Date(doc.data().createdAt).toLocaleDateString()
        }));
        setMyProjects(projectsData.filter(p => p.userId === user.uid));
        setSharedProjects(projectsData.filter(p => p.userId !== user.uid));
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProjects();
  }, [user]);

  if (isLoading) {
    return (
      <div className="home-page">
        <div className="loading-spinner">Loading projects...</div>
      </div>
    );
  }

  return (
    <div className="home-page">
      {user ? (
        <>
          <h1 className="page-title">My Projects</h1>
          {(!myProjects || myProjects.length === 0) ? (
            <div className="no-projects">
              <p>You haven't created any projects yet.</p>
              <Link to="/create" className="create-link">
                Create your first project
              </Link>
            </div>
          ) : (
            <div className="projects-grid">
              {myProjects.map(project => (
                <Link
                  key={project.id}
                  to={`/project/${project.id}`}
                  className="project-card"
                >
                  <div className="project-header">
                    <h3 className="project-title">{project.title || 'Untitled Project'}</h3>
                    <hr className="project-divider" />
                    <span className="project-date">Created: {project.createdAt}</span>
                  </div>
                  <div className="project-description">
                    {project.description || project.lastMessage || 'No description available.'}
                  </div>
                </Link>
              ))}
            </div>
          )}

          <h1 className="page-title">Shared Apps</h1>
          {(!sharedProjects || sharedProjects.length === 0) ? (
            <div className="no-projects">
              <p>No shared apps available.</p>
            </div>
          ) : (
            <div className="projects-grid">
              {sharedProjects.map(project => (
                <Link
                  key={project.id}
                  to={`/display/${project.id}`}
                  className="project-card"
                >
                  <div className="project-header">
                    <h3 className="project-title">{project.title || 'Untitled Project'}</h3>
                    <hr className="project-divider" />
                    <span className="project-date">Created: {project.createdAt}</span>
                  </div>
                  <div className="project-description">
                    {project.description || project.lastMessage || 'No description available.'}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </>
      ) : (
        <div className="login-prompt">
          <h2>Welcome to App Creator</h2>
          <p>Please log in to view and create projects.</p>
        </div>
      )}

      {user && (
        <Link to="/create" className="create-button">
          <FaPlus />
        </Link>
      )}
    </div>
  );
}

export default HomePage;